<mat-drawer-container class="w-full h-screen grid grid-cols-1 md:grid-cols-[250px_calc(100vw-250px)] overflow-x-hidden">
  <mat-drawer mode="side" class="hidden md:block" opened>
    <!-- Sidebar contenido -->
  </mat-drawer>

  <mat-drawer-content class="bg-soberania">
    <app-admin-toolbar></app-admin-toolbar>
    <div class="px-5 py-4 flex justify-center">
      <div class="grow">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
